import React from 'react';

const ShareIcon: React.FC<
  React.PropsWithChildren<React.SVGProps<SVGSVGElement>>
> = (props) => {
  return (
    <svg
      role="presentation"
      xmlns="http://www.w3.org/2000/svg"
      width="17.014"
      height="17.014"
      viewBox="0 0 17.014 17.014"
      {...props}
    >
      <g
        fill="none"
        fillRule="evenodd"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      >
        <path d="M15.078 9.475v6.228c0 .724-.587 1.311-1.311 1.311H1.311A1.311 1.311 0 010 15.704V3.246c0-.724.587-1.31 1.311-1.31h6.228"></path>
        <path d="M12.206 0.5L16.514 0.5"></path>
        <path d="M16.514 4.808L16.514 0.5"></path>
        <path d="M8.616 8.398L16.514 0.5"></path>
      </g>
    </svg>
  );
};

export default ShareIcon;
